import { BaseReducer } from '@identic/api';
import { SampleState, SampleInitialState, SampleActions } from './sample.state';

export function SampleReducer(state: SampleState = SampleInitialState, action: any): SampleState {
  return BaseReducer(state, action, SampleActions);
}
// console.log(`%cSampleReducer::ngOnInit`, 'background:yellow');
